import * as React from 'react'

import { useMutation } from '@tanstack/react-query'
import { uploadFileToRepo } from '../lib/file-utils'
import { getFileHashSHA256 } from '@basehub/data/blob/file-utils'

export const useUploadFileToRepoMutation = () => {
  const [progress, setProgress] = React.useState(0)

  const mutation = useMutation(
    async ({
      file,
      repoId,
      teamId,
    }: {
      file: File
      repoId: string
      teamId: string
    }) => {
      const { uploadURL } = await uploadFileToRepo(file, {
        repoId,
        teamId,
        fileHash: await getFileHashSHA256(file),
        onUploadProgress: ({ progress }) => {
          if (!progress) return
          setProgress(Math.floor(progress * 100))
        },
      })

      return { uploadURL }
    },
    {
      onSuccess: () => setProgress(0),
      onError: () => setProgress(0),
    }
  )

  return { ...mutation, progress }
}
